import React, { useState } from 'react';

import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app

const Menu = (props) => {
  const foods = props.menus
  const menuCategories = props.menuCategories
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const [tag, setTag] = useState(menuCategories[0].id)



  return (
    <div className="menu">
      <div className="kingfisher">
        <div className="budweiser">
          <div className="busShade">
            <p className="text-center py-5">MENU</p>
            <div className="menuCategory ">
              {
                menuCategories.map((item, index) =>
                  <div key={item.id} className={
                    "categorie " + `${tag === item.id ? 'active' : ''}`} onClick={() => setTag(item.id)}>{item.name.toUpperCase()}</div>
                )
              }
            </div>
            <div className="container-fluid menuContainer p-5">
              <div className="row menuItems p-3">
                {foods.filter((food) => { return food.category.id === tag }).map((menu, index) => {
                  return (
                    <div key={menu.id} className="image col-12 col-md-6" onClick={() => {
                      setPhotoIndex(index)
                      setIsOpen(true)
                    }
                    }>
                      <img className="w-100" src={`${process.env.REACT_APP_IMAGE_STORAGE}${menu.image}`} alt="menuPhoto" />
                    </div>
                  )
                })}


                {isOpen && (
                  <Lightbox
                    mainSrc={`${process.env.REACT_APP_IMAGE_STORAGE}${foods[photoIndex]['image']}`}
                    onImageLoad={() => {
                      window.dispatchEvent(new Event('resize'));
                    }}
                    nextSrc={`${process.env.REACT_APP_IMAGE_STORAGE}${foods[(photoIndex + 1) % foods.length]['image']}`}
                    prevSrc={`${process.env.REACT_APP_IMAGE_STORAGE}${foods[(photoIndex + foods.length - 1) % foods.length]['image']}`}
                    onCloseRequest={() => setIsOpen(false)}
                    onMovePrevRequest={() =>
                      setPhotoIndex(
                        (photoIndex + foods.length - 1) % foods.length,
                      )
                    }
                    onMoveNextRequest={() =>
                      setPhotoIndex(
                        (photoIndex + 1) % foods.length,
                      )
                    }
                    imageCaption={<div style={{ padding: '16px', margin:'auto' }}>{foods[photoIndex]['menu_content']}</div>}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Menu;